var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',{staticClass:"text-h6 text-center"},[_vm._v("P Gets Woke About Safer Sex")]),_c('p',[_vm._v("P decides to follow Nico’s advice and gets himself to an HIV/STI clinic. Their friend Tommy works there.")])])}
var staticRenderFns = []

export { render, staticRenderFns }